export var DomainVerificationStatus;
(function (DomainVerificationStatus) {
    DomainVerificationStatus["PENDING"] = "PENDING";
    DomainVerificationStatus["VERIFIED"] = "VERIFIED";
    DomainVerificationStatus["UNVERIFIED"] = "UNVERIFIED";
})(DomainVerificationStatus || (DomainVerificationStatus = {}));
export var DomainVerificationAttemptSource;
(function (DomainVerificationAttemptSource) {
    DomainVerificationAttemptSource["MANUAL"] = "MANUAL";
    DomainVerificationAttemptSource["INVITE_JOIN"] = "INVITE_JOIN";
})(DomainVerificationAttemptSource || (DomainVerificationAttemptSource = {}));
export var DomainVerificationAttemptResult;
(function (DomainVerificationAttemptResult) {
    DomainVerificationAttemptResult["VERIFIED"] = "VERIFIED";
    DomainVerificationAttemptResult["RECORD_MISSING"] = "RECORD_MISSING";
    DomainVerificationAttemptResult["DNS_ERROR"] = "DNS_ERROR";
})(DomainVerificationAttemptResult || (DomainVerificationAttemptResult = {}));
//# sourceMappingURL=domain-verification.enum.js.map